"use client";

import React from "react";

const TreatmentTimeline: React.FC = () => {
  return (
    <section className="w-full py-6 sm:py-8 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-8 md:px-12 space-y-6 text-center md:text-left">
        <h2
          className="
            text-2xl sm:text-3xl font-semibold text-gray-800 text-center
            pb-6 after:content-[''] after:block after:w-[200px] after:h-[3px] after:mx-auto after:mt-2
            after:bg-[linear-gradient(to_right,#AE7D2F_0%,#ECD05B_50%,#AE7D2F_100%)]
          "
        >
          How Long Does Treatment Take?
        </h2>
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
          Most treatments take 6 to 18 months, depending on the complexity of
          the case. Many patients notice visible results within just a few
          weeks.
        </p>

        <div className="overflow-x-auto pt-4">
          <table className="w-full border-collapse border border-gray-300 text-left text-gray-700 text-sm sm:text-base">
            <thead className="bg-gray-100">
              <tr>
                <th className="border border-gray-300 px-4 py-3 font-semibold">
                  Case Complexity
                </th>
                <th className="border border-gray-300 px-4 py-3 font-semibold">
                  Approximate Timeline
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border border-gray-300 px-4 py-3">
                  Mild misalignment or minor spacing
                </td>
                <td className="border border-gray-300 px-4 py-3">
                  6 months or less
                </td>
              </tr>
              <tr className="bg-gray-50">
                <td className="border border-gray-300 px-4 py-3">
                  Moderate crowding, gaps, or bite issues
                </td>
                <td className="border border-gray-300 px-4 py-3">12-18 months</td>
              </tr>
              <tr>
                <td className="border border-gray-300 px-4 py-3">
                  Complex cases (severe bite, significant crowding)
                </td>
                <td className="border border-gray-300 px-4 py-3">
                  Up to 24 months
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <p className="text-gray-700 text-base sm:text-lg leading-relaxed pt-2">
          A few key factors influence your timeline:
        </p>
        <ul className="list-disc list-inside space-y-3 text-gray-700 text-base sm:text-lg leading-relaxed">
          <li>
            <strong>Severity of Misalignment:</strong> More complex cases
            require more aligner sets.
          </li>
          <li>
            <strong>Compliance:</strong> Wearing aligners 20&ndash;22 hours per
            day is the single biggest factor in staying on schedule.
          </li>
          <li>
            <strong>Follow-Up Visits:</strong> Attending check-ups every
            6&ndash;8 weeks keeps treatment progressing as planned.
          </li>
        </ul>
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed group hover:bg-gray-50 transition-all duration-300 rounded-md py-1">
          During your free consultation, we&apos;ll provide a personalized
          timeline based on your specific case.
        </p>
      </div>
    </section>
  );
};

export default TreatmentTimeline;
